import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-12 md:mb-16">
          {/* Company Info */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
              회사소개
            </h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a href="/about" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  대표 인사말
                </a>
              </li>
              <li>
                <a href="/about" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  사업 목표
                </a>
              </li>
              <li>
                <a href="/about" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  브랜드 의미
                </a>
              </li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
              사업 프로그램
            </h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a href="/programs" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  원데이클래스
                </a>
              </li>
              <li>
                <a href="/programs" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  진로콘서트
                </a>
              </li>
              <li>
                <a href="/programs" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  국제교류 프로그램
                </a>
              </li>
              <li>
                <a href="/programs" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  진로 특강
                </a>
              </li>
              <li>
                <a href="/programs" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  대학 탐방
                </a>
              </li>
              <li>
                <a href="/programs" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  창업 & 자격증
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
              고객지원
            </h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a href="/support#notice" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  공지사항
                </a>
              </li>
              <li>
                <a href="/support#faq" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  자주 묻는 질문
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6" style={{ fontFamily: 'Pretendard, sans-serif' }}>
              문의하기
            </h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a href="/apply" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  프로그램 신청
                </a>
              </li>
              <li>
                <a href="tel:0507-1361-2932" className="text-sm md:text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  전화 문의
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 md:pt-12 border-t border-white/10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-8">
            {/* Address */}
            <div className="text-xs md:text-sm text-white/60 leading-relaxed">
              <p className="mb-1 md:mb-2">
                <strong className="text-white/80">Branch (브란치)</strong>
              </p>
              <p>서울시 강동구 올림픽로 98가길 47</p>
              <p>전화: 0507-1361-2932</p>
            </div>

            {/* Social Links */}
            <div className="flex items-center gap-4 md:gap-6">
              <a
                href="#"
                className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg md:text-xl"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg md:text-xl"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-fill text-lg md:text-xl"></i>
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-8 md:mt-12 text-center">
            <p className="text-xs md:text-sm text-white/40">
              © 2024 Branch. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;